import { useCallback } from "react";
import { useDeleteTakeWithCleanup } from "../../hooks/DeleteTakeHook";
import Take3D from "../../models/Take3D";

export function useDeleteTake3D() {
  const { deleteTakeWithCleanup } = useDeleteTakeWithCleanup();

  const deleteTake3D = useCallback(
    (take: Take3D) => {
      deleteTakeWithCleanup(take);
    },
    [deleteTakeWithCleanup]
  );

  return { deleteTake3D } as const;
}
